export const home = {
  // Hero
  hero: {
    tag: '언어 교육 인프라 개혁 커뮤니티',
    titleHighlight: '"가르치는 것"',
    titleRest: '을 더 자유롭게,',
    titleLine2: '더 가깝게.',
    subtext:
      'EachTeach는 개인 언어 가정교사가 최대한의 성과를 발휘하고, 교육의 질을 모두가 함께 높일 수 있는 환경의 커뮤니티입니다.',
    ctaRegister: '커뮤니티에 등록하기',
    ctaServices: '서비스 보기',
    scroll: 'SCROLL',
    stats: {
      categories: '대상 구분',
      slaExperts: '전문가 참여',
      possibilities: '배움의 가능성',
    },
  },

  // Philosophy
  philosophy: {
    label: 'Philosophy',
    visionLabel: 'Our Vision',
    visionQuote: '커뮤니티의 지원을 통한 교육 인프라의 근본적 개혁',
    heading: 'EachTeach가 지향하는 것',
    paragraph1:
      '우리는 개인 언어 가정교사가 "자립한 교육자"로서 지속적으로 활동할 수 있는 사회 인프라 구축을 목표로 합니다. 뛰어난 교사가 고립되지 않고 전문 지식과 경험을 서로 공유할 수 있는 장을 만들어 언어 교육 전체의 질을 끌어올립니다.',
    paragraph2Before:
      'SLA(제2언어 습득)의 최신 연구를 실천에 활용하고 과학적 근거에 기반한 지도법을 널리 퍼뜨려 가르치는 것의 가능성을 확장해 나갑니다. 그것이 ',
    paragraph2Highlight: 'EachTeach의 핵심 가치',
    paragraph2After: '입니다.',
    values: {
      independence: '자립',
      coCreation: '공동 창조',
      expertise: '전문성',
      evidence: '과학적 근거',
      diversity: '다양성',
    },
  },

  // Course Flow
  courseFlow: {
    label: 'Course Flow',
    heading: '코스 흐름',
    intro:
      '언어 교환에서 시작하여 가정교사의 보조를 받으면서 레벨에 맞는 단계적인 배움으로 나아갑니다.',
    step1Title: '언어 교환',
    step1Desc:
      '먼저 언어 교환부터 시작합니다. 학습자 간・교사와의 교류를 통해 배움의 토대와 동료를 만듭니다.',
    step2Title: '가정교사 보조',
    step2Desc:
      '개인 가정교사의 지원을 받으며 학습을 진행합니다. 전문가의 피드백으로 질을 보장합니다.',
    levelCourseTitle: '레벨별 코스',
    levelA: '입문・기초 (A)',
    levelB1: '중급 전반 (B1)',
    levelB2: '중급 후반 (B2)',
    levelC: '상급 (C)',
    levelNote:
      '현재 숙련도에 맞춰 A / B1 / B2 / C 각 단계로. 레벨 체크로 최적의 시작 지점을 진단합니다.',
  },

  // CTA Banner
  cta: {
    label: 'Join Us',
    heading: '지금 바로 커뮤니티에 참여하지 않으시겠어요?',
    subtext:
      '개인 언어 가정교사, 교사를 꿈꾸는 분, SLA 전문가 등 모든 분의 참여를 기다립니다.',
    button: '커뮤니티에 등록하기',
  },
};
